module.exports = __webpack_public_path__ + "img/velocimetro.49d7b746.svg";